import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'onboardingPages.clientOnboarding.fitnessGoalsStep.description',
    defaultMessage:
      'This way we will know exactly what you are aiming for and use filters to optimize content to fit you perfectly. (Maximum 3 goals)',
  },
  title: {
    id: 'onboardingPages.clientOnboarding.fitnessGoalsStep.title',
    defaultMessage: 'What is your goal?',
  },
});

export default messages;
